import $ from "jquery";
import { render } from "../utils/template";
import { get } from "jquery";
import debounce from "lodash/debounce";

export function SearchDictionary(element, container) {
  const containers = document.querySelectorAll(container);
  const DEBOUNCE_TIME = 500;
  const DISABLED_CLASS = "is-disabled";
  const loader = document.querySelector(element.dataset.loader);
  const form = formFind(element);

  function formFind(element) {
    parent = element.parentNode;
    if (parent.nodeName != "FORM") {
      formFind(parent);
    }
    return parent;
  }

  function handleLoading(status = "start") {
    if (status == "start") {
      form.classList.add(DISABLED_CLASS);
      loader.classList.add("is-active");
    } else {
      form.classList.remove(DISABLED_CLASS);

      loader.classList.remove("is-active");
    }
  }

  function getResults(query, context) {
    handleLoading();

    var input = document.getElementById("dicrionary");
    var isEmpty =
      document.getElementById("main-search-results2").innerHTML === "";
    get(
      teik.ajax_url,
      {
        action: "custom_search_1",
        search: query,
        context
      },
      res => {
        $("html,body").animate(
          {
            scrollTop: $("#pagecontent").offset().top - 250
          },
          100
        );
        if (input.value.length != 0) {
          document.getElementById("default-dictionary").style.display = "none";
          document.getElementById("main-search-results2").style.display =
            "block";

          let html = "";
          res.forEach(item => {
            if (item.url === "") {
              $(".read-more-dictionary").removeClass("d-block");
              $(".read-more-dictionary").addClass("d-none");
            } else {
              $(".read-more-dictionary").addClass("d-block");
              $(".read-more-dictionary").removeClass("d-none");
            }

            html += render("search-result-template-dictionary", item);
          });
          _updateContainers(html);
          if (html === "") {
            let href = document.getElementById("dicrionary").value;
            let parse_url = href.trim().replace(/ /g, "%20");

            if (item.url === "") {
              $(".read-more-dictionary").removeClass("d-block");
              $(".read-more-dictionary").addClass("d-none");
            } else {
              $(".read-more-dictionary").addClass("d-block");
              $(".read-more-dictionary").removeClass("d-none");
            }

            document.getElementById("main-search-results2").innerHTML +=
              "Słownik pojęć nie zawiera podanej frazy. " +
              "<a href=" +
              document.location.origin +
              "/telecube/szukaj/" +
              parse_url +
              ">Przejdź do wyszukiwarki globalnej</a>";
          }
        } else {
          document.getElementById("main-search-results2").style.display =
            "none";
          document.getElementById("default-dictionary").style.display = "block";
        }

        handleLoading("finished");
      }
    );
  }

  function _updateContainers(template) {
    containers.forEach(element => {
      element.innerHTML = template;
    });
  }
  const deboundedSearch = debounce((value, context) => {
    getResults(value, context);
  }, DEBOUNCE_TIME);

  function handleChange(e) {
    const contextInput = form.querySelector(".context-input");
    let context = "";
    if (contextInput) {
      context = contextInput.value;
    }
    deboundedSearch(e.target.value, context);
  }

  element.addEventListener("keyup", handleChange);
}
